/** @jsxImportSource @emotion/react */

import Button from '@mui/material/Button'
import { FC } from 'react'
import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg'
import * as classes from './styles'

interface IProps {
  isEditMode?: boolean
  removeLoading?: boolean
  submitting?: boolean
  onDelete: () => void
  onClose: () => void
}

const FormButtons: FC<IProps> = ({ onClose, onDelete, isEditMode, submitting, removeLoading }) => (
  <div css={classes.buttons}>
    <div>
      {isEditMode && (
        <Button variant="outlined" color="red" size="large" onClick={onDelete} fullWidth>
          <TrashIcon />
          {removeLoading ? '...Loading' : 'Delete'}
        </Button>
      )}
      <Button variant="outlined" color="blue" size="large" onClick={onClose} fullWidth>
        Cancel
      </Button>
    </div>
    <Button variant="contained" type="submit" color="blue" size="large" fullWidth>
      {submitting ? '...Loading' : 'Submit'}
    </Button>
  </div>
)

export default FormButtons
